"use client";

import { useState } from "react";
import { FaWhatsapp, FaXTwitter, FaLinkedinIn, FaLink } from "react-icons/fa6";

type Props = {
  url: string;
  title: string;
  labelTitle: string;
  labelCopy: string;
  labelCopied: string;
};

export function ShareButtons({ url, title, labelTitle, labelCopy, labelCopied }: Props) {
  const [copied, setCopied] = useState(false);

  const enc = encodeURIComponent;
  const wa = `https://wa.me/?text=${enc(`${title} ${url}`)}`;
  const tw = `https://twitter.com/intent/tweet?url=${enc(url)}&text=${enc(title)}`;
  const li = `https://www.linkedin.com/sharing/share-offsite/?url=${enc(url)}`;

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      // ignore
    }
  };

  const base =
    "inline-flex h-10 w-10 items-center justify-center rounded-full border border-base-200 bg-white text-dark-muted transition hover:bg-base-100 hover:text-tprimary-2";

  return (
    <div className="flex items-center gap-3">
      <span className="text-sm font-semibold text-dark-muted">{labelTitle}:</span>
      <a href={wa} target="_blank" rel="noreferrer noopener" aria-label="WhatsApp" className={base}>
        <FaWhatsapp className="h-4 w-4" />
      </a>
      <a href={tw} target="_blank" rel="noreferrer noopener" aria-label="X / Twitter" className={base}>
        <FaXTwitter className="h-4 w-4" />
      </a>
      <a href={li} target="_blank" rel="noreferrer noopener" aria-label="LinkedIn" className={base}>
        <FaLinkedinIn className="h-4 w-4" />
      </a>
      <button type="button" onClick={onCopy} aria-label={labelCopy} className={base}>
        <FaLink className="h-4 w-4" />
      </button>
      {copied && (
        <span className="text-xs font-medium text-tprimary-2">{labelCopied}</span>
      )}
    </div>
  );
}
